import { render, staticRenderFns } from "./BaseProgressbar.vue?vue&type=template&id=feda6e3a&scoped=true&lang=pug&"
import script from "./BaseProgressbar.vue?vue&type=script&lang=js&"
export * from "./BaseProgressbar.vue?vue&type=script&lang=js&"
import style0 from "./BaseProgressbar.vue?vue&type=style&index=0&id=feda6e3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feda6e3a",
  null
  
)

export default component.exports